/* ==========================================================================
   PERIOD 5.0, Kategorie-Logik (Michelle-Umbau P09, Stand 29.10.2026)
   sections/period5-collection-grid.liquid, snippets/period5-collection-card.liquid, snippets/period5-size-sheet.liquid.
   Spec docs/michelle-spec/30-kategorie.md §7, §8b, §8d, §10, §11.
   1. Sortieren: Wechsel im nativen Select setzt ?sort_by= (Seite 1), übrige Parameter bleiben (z. B. Vorschau).
   2. «Mehr Produkte ansehen»: zeigt alle Karten der Seite, Fokus auf die erste neue Karte, Button verschwindet;
      gibt es eine weitere Seite (data-next-url), lädt er sie per Section Rendering API nach.
   3. Farb-Thumbs: schalten die Farbe der Karte (Variante, Bild, Preis); ohne Grösse legt der Button diese Variante ab.
   4. Grössen-Sheet: öffnet per showModal (Fokus bleibt im Sheet, Escape nativ), Vorauswahl erste verfügbare Grösse zur
      gewählten Farbe; Schliessen über × und Overlay macht assets/period5-sections.js ([data-p5-close], dialog.p5-dialog).
   5. Quick-Add (Karte und Sheet): POST /cart/add.js mit id, quantity, selling_plan (leer, kein Abo im Frontend) und
      den Sections des Cart-Drawers; danach rendert und öffnet der Drawer (Dawn cart-drawer.renderContents, vorher
      is-empty am <cart-drawer> entfernt wie Dawn product-form.js), Header-Zähler über Dawns cartUpdate. Storefront-
      Ereignisse CartLinesUpdateEvent / CartErrorEvent wie Dawn product-form.js; Submit im Capture von window abgefangen
      (genau ein product_added_to_cart aus dem Request, keins aus dem Formular-Beobachter). Tracking: add_to_cart
      über window.P5.track (assets/period5-events.js, nicht geändert); select_item feuert assets/period5-sections.js
      an [data-p5-select-item].
   Ohne JavaScript: Formulare gehen an /cart/add (Dawn-Weg), Sortieren per Button, alle Karten sichtbar.
   ========================================================================== */
(function () {
  'use strict';
  if (window.P5Collection) return;
  window.P5Collection = true;

  var track = function (name, payload) {
    if (window.P5 && window.P5.track) window.P5.track(name, payload);
  };
  var currency = function () {
    return (window.P5 && window.P5.config && window.P5.config.currency) || undefined;
  };

  /* --- 1. Sortieren ------------------------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('[data-p5-sort]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    var face = select.form && select.form.querySelector('[data-p5-sort-value]');
    if (face && select.selectedOptions[0]) face.textContent = select.selectedOptions[0].textContent;
    window.location.assign(url.toString());
  });

  /* --- 2. «Mehr Produkte ansehen» ------------------------------------------------------------------------ */
  var isShown = function (el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  };
  function loadNextPage(root, grid, wrap, btn) {
    var next = root.getAttribute('data-next-url');
    if (!next) return Promise.resolve(null);
    var url = new URL(next, window.location.origin);
    url.searchParams.set('section_id', root.getAttribute('data-section-id'));
    btn.setAttribute('aria-busy', 'true');
    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextRoot = doc.querySelector('[data-p5-collection-grid]');
        var items = doc.querySelectorAll('[data-p5-grid] > .p5-cgrid__item');
        var first = null;
        Array.prototype.forEach.call(items, function (li) {
          var node = document.importNode(li, true);
          node.classList.remove('p5-cgrid__item--more-m', 'p5-cgrid__item--more-d');
          grid.appendChild(node);
          if (!first) first = node;
        });
        var nn = nextRoot && nextRoot.getAttribute('data-next-url');
        if (nn) root.setAttribute('data-next-url', nn);
        else {
          root.removeAttribute('data-next-url');
          wrap.classList.remove('is-paged');
          wrap.hidden = true;
        }
        btn.removeAttribute('aria-busy');
        return first;
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        return null;
      });
  }
  function focusCard(li) {
    var link = li && li.querySelector('.p5-ccard__link');
    if (link) link.focus({ preventScroll: false });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-p5-more]');
    if (!btn) return;
    var root = btn.closest('[data-p5-collection-grid]');
    var grid = root && root.querySelector('[data-p5-grid]');
    var wrap = btn.closest('[data-p5-more-wrap]');
    if (!grid || !wrap) return;
    if (grid.classList.contains('is-collapsed')) {
      var hidden = Array.prototype.filter.call(grid.children, function (li) {
        return !isShown(li);
      });
      grid.classList.remove('is-collapsed');
      if (root.getAttribute('data-next-url')) wrap.classList.add('is-paged');
      else wrap.hidden = true;
      if (hidden.length) focusCard(hidden[0]);
      return;
    }
    loadNextPage(root, grid, wrap, btn).then(focusCard);
  });

  /* --- Varianten der Karte ---------------------------------------------------------------------------------- */
  var variantsOf = function (card) {
    if (card._p5Variants) return card._p5Variants;
    var el = card.querySelector('script[data-p5-ccard-variants]');
    try {
      card._p5Variants = el ? JSON.parse(el.textContent) : [];
    } catch (err) {
      card._p5Variants = [];
    }
    return card._p5Variants;
  };
  var idx = function (card, name) {
    var v = card.getAttribute('data-' + name + '-index');
    return v === null ? -1 : parseInt(v, 10);
  };
  var selectedColor = function (card) {
    var t = card.querySelector('.p5-ccard__thumb[aria-pressed="true"]');
    return t ? t.getAttribute('data-p5-color') : null;
  };
  function findVariant(card, size, color) {
    var si = idx(card, 'size');
    var ci = idx(card, 'color');
    var list = variantsOf(card);
    var match = function (v, needAvailable) {
      if (needAvailable && !v.available) return false;
      if (si >= 0 && size !== null && v.options[si] !== size) return false;
      if (ci >= 0 && color !== null && v.options[ci] !== color) return false;
      return true;
    };
    for (var i = 0; i < list.length; i++) if (match(list[i], true)) return list[i];
    for (var j = 0; j < list.length; j++) if (match(list[j], false)) return list[j];
    return null;
  }
  function setButtonData(btn, v) {
    if (!btn || !v) return;
    btn.dataset.variantId = v.id;
    btn.dataset.sku = v.sku || '';
    btn.dataset.price = v.price;
  }
  function applyVariant(card, v) {
    if (!v) return;
    var input = card.querySelector('[data-p5-ccard-form] [data-p5-variant-input]');
    if (input) input.value = v.id;
    setButtonData(card.querySelector('[data-p5-ccard-form] [data-p5-quick-add]'), v);
    card.querySelectorAll('[data-p5-select-item]').forEach(function (a) {
      a.dataset.variantId = v.id;
      a.dataset.sku = v.sku || '';
      a.dataset.price = v.price;
    });
    var price = card.querySelector('[data-p5-ccard-price] .p5-ccard__price-now');
    if (price && v.price_html) price.textContent = v.price_html;
    var img = card.querySelector('.p5-ccard__img');
    if (img && v.image) {
      img.removeAttribute('srcset');
      img.src = v.image;
    }
  }

  /* --- 3. Farb-Thumbs -------------------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.p5-ccard__thumb');
    if (!thumb || thumb.disabled) return;
    var card = thumb.closest('[data-p5-ccard]');
    if (!card) return;
    card.querySelectorAll('.p5-ccard__thumb').forEach(function (t) {
      t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
    });
    var color = thumb.getAttribute('data-p5-color');
    var current = card.querySelector('[data-p5-ccard-form] [data-p5-variant-input]');
    var size = null;
    if (idx(card, 'size') >= 0 && current) {
      var cur = variantsOf(card).filter(function (v) {
        return String(v.id) === current.value;
      })[0];
      if (cur) size = cur.options[idx(card, 'size')];
    }
    applyVariant(card, findVariant(card, size, color));
  });

  /* --- 4. Grössen-Sheet -------------------------------------------------------------------------------------- */
  function syncSheet(card, sheet) {
    var color = selectedColor(card);
    var si = idx(card, 'size');
    var radios = sheet.querySelectorAll('[data-p5-size]');
    var firstOk = null;
    var checkedOk = null;
    radios.forEach(function (r) {
      var v = findVariant(card, r.value, color);
      var ok = !!(v && v.available && v.options[si] === r.value);
      r.disabled = !ok;
      if (ok && !firstOk) firstOk = r;
      if (ok && r.checked) checkedOk = r;
    });
    var pick = checkedOk || firstOk;
    if (pick) pick.checked = true;
    updateSheetVariant(card, sheet);
    var v = pick ? findVariant(card, pick.value, color) : null;
    var img = sheet.querySelector('.p5-csheet__img');
    if (img && v && v.image) {
      img.removeAttribute('srcset');
      img.src = v.image;
    }
  }
  function updateSheetVariant(card, sheet) {
    var checked = sheet.querySelector('[data-p5-size]:checked');
    var v = findVariant(card, checked ? checked.value : null, selectedColor(card));
    var input = sheet.querySelector('[data-p5-variant-input]');
    var cta = sheet.querySelector('[data-p5-quick-add]');
    if (v && input) input.value = v.id;
    setButtonData(cta, v);
    if (cta) cta.disabled = !(v && v.available);
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-p5-sheet-open]');
    if (!opener) return;
    var sheet = document.getElementById(opener.getAttribute('data-p5-sheet-open'));
    var card = opener.closest('[data-p5-ccard]');
    if (!sheet || !card || !sheet.showModal) return;
    e.preventDefault();
    sheet._p5Opener = opener;
    syncSheet(card, sheet);
    sheet.showModal();
  });
  /* Fokusfang: showModal macht den Rest der Seite inert, Tab liefe aber in die Browser-Leiste; hier im Kreis */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var sheet = document.querySelector('dialog[data-p5-csheet][open]');
    if (!sheet) return;
    var items = Array.prototype.filter.call(
      sheet.querySelectorAll('button:not([disabled]), input:not([disabled]):not([type="hidden"]), a[href], [tabindex]:not([tabindex="-1"])'),
      function (el) {
        if (el.type === 'radio' && !el.checked && sheet.querySelector('input[name="' + el.name + '"]:checked')) return false;
        return isShown(el) || el.type === 'radio';
      }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || !sheet.contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !sheet.contains(active))) {
      e.preventDefault();
      first.focus();
    }
  });
  document.addEventListener('change', function (e) {
    var radio = e.target.closest && e.target.closest('[data-p5-size]');
    if (!radio) return;
    var sheet = radio.closest('[data-p5-csheet]');
    var card = radio.closest('[data-p5-ccard]');
    if (sheet && card) updateSheetVariant(card, sheet);
  });

  /* --- 5. Quick-Add ------------------------------------------------------------------------------------------- */
  function showError(form, msg) {
    var box = form.querySelector('[data-p5-ccard-error]');
    if (!box) return;
    box.textContent = msg || 'Konnte nicht in den Warenkorb gelegt werden.';
    box.hidden = false;
  }
  /* Storefront-Standard-Ereignisse wie Dawns product-form.js (createCartLinesUpdateEvent / resolveCartLinesUpdate /
     dispatchCartErrorEvent): ohne CartLinesUpdateEvent baut Shopify product_added_to_cart nur aus dem Formular, ohne
     Produkttitel, und App-Web-Pixel brechen ab (Prüfung Welle 4, Befund 4). window.StandardEvents setzt layout/theme.liquid. */
  function startLinesUpdate(form, variantId, quantity) {
    var SE = window.StandardEvents || {};
    if (!SE.CartLinesUpdateEvent || !variantId) return null;
    var deferred = SE.CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(
      new SE.CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: quantity }],
        promise: deferred.promise
      })
    );
    return deferred;
  }
  function resolveLinesUpdate(deferred) {
    var SE = window.StandardEvents || {};
    if (!deferred || !SE.CartLinesUpdateEvent) return;
    var pending =
      typeof CartItems !== 'undefined' && typeof CartItems.fetchCartData === 'function'
        ? CartItems.fetchCartData()
        : fetch(window.routes.cart_url + '.json', { credentials: 'same-origin' }).then(function (r) {
            return r.json();
          });
    pending
      .then(function (cart) {
        if (!cart || !cart.currency) return deferred.reject(new Error('Missing currency in cart response'));
        deferred.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
      })
      .catch(function (err) {
        deferred.reject(err);
      });
  }
  function cartError(form, message, code) {
    var SE = window.StandardEvents || {};
    if (SE.CartErrorEvent) form.dispatchEvent(new SE.CartErrorEvent({ error: message, code: code }));
  }
  /* Submit im Capture-Teil von window: preventDefault, bevor Shopifys Formular-Beobachter (Capture auf document) die
     Ablage als Formular-Submit zählt. Sonst entsteht auf der Kategorie ein zweites product_added_to_cart ohne
     Produkttitel (keine Produktseite), an dem App-Web-Pixel abbrechen (Prüfung Welle 4, Befund 4; Sonde
     docs/qa-screens/2026-10-28-michelle/P09/fix-r1/pixel-sonde.txt). Das vollständige Ereignis aus dem Ablage-Request
     bleibt (wie beim Cross-Sell «+» im Cart). Ohne Drawer oder fetch kein preventDefault (Dawn-Weg /cart/add). */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-p5-ccard-form], [data-p5-csheet-form]')) return;
    var btn = form.querySelector('[data-p5-quick-add]');
    if (!btn) {
      e.preventDefault();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return; // Dawn-Weg: /cart/add → /cart
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('aria-busy', 'true');
    var err = form.querySelector('[data-p5-ccard-error]');
    if (err) err.hidden = true;

    var fd = new FormData(form);
    if (!fd.has('selling_plan')) fd.append('selling_plan', '');
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    var sheet = form.closest('[data-p5-csheet]');
    var card = form.closest('[data-p5-ccard]');
    var returnFocus = (sheet && sheet._p5Opener) || btn;
    if (drawer.getSectionsToRender) {
      fd.append(
        'sections',
        drawer
          .getSectionsToRender()
          .map(function (s) {
            return s.id;
          })
          .join(',')
      );
      fd.append('sections_url', window.location.pathname);
    }
    var linesUpdate = startLinesUpdate(form, fd.get('id'), qty);
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('aria-disabled');
        if (res.status) {
          var msg = res.description || res.message;
          showError(form, msg);
          cartError(form, msg, 'INVALID');
          if (linesUpdate) linesUpdate.reject(new Error(msg));
          return;
        }
        resolveLinesUpdate(linesUpdate);
        var root = form.closest('[data-p5-collection-grid]');
        var price = Number(btn.dataset.price) || 0;
        var item = window.P5
          ? window.P5.item({
              sku: btn.dataset.sku,
              variant_id: res.variant_id || btn.dataset.variantId,
              product_id: btn.dataset.productId,
              title: btn.dataset.title,
              variant_title: res.variant_title,
              price: price,
              quantity: qty,
              handle: card && card.getAttribute('data-handle'),
              category: btn.dataset.category || undefined
            })
          : {};
        var li = form.closest('.p5-cgrid__item');
        if (li && li.dataset.p5CardIndex) item.index = parseInt(li.dataset.p5CardIndex, 10);
        track('add_to_cart', {
          source: sheet ? 'collection_size_sheet' : 'collection_card',
          item_list_name: root ? root.querySelector('[data-p5-select-item]')?.dataset.list || '' : '',
          ecommerce: { currency: currency(), value: Math.round(price * qty * 100) / 100, items: [item] }
        });
        if (sheet && sheet.open) sheet.close();
        if (drawer.setActiveElement) drawer.setActiveElement(returnFocus);
        /* Wie Dawn product-form.js und period5-pdp.js: sonst bleibt is-empty am <cart-drawer> (Footer mit Summe und
           Kasse ausgeblendet, period5-cart.css), und Dawns open() ruft trapFocus mit null (Prüfung Welle 4, Befund 3) */
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        if (res.sections) drawer.renderContents(res);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'collection-card', productVariantId: res.variant_id, cartData: res });
        }
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('aria-disabled');
        showError(form);
        cartError(form, (err && err.message) || 'Network error', 'SERVICE_UNAVAILABLE');
        if (linesUpdate) linesUpdate.reject(err);
      });
  }, true);
})();
